var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "financeCalculator__form__input financeCalculator__form__input--select",
    },
    [
      _vm.selectedOption
        ? _c(
            "div",
            { staticClass: "financeCalculator__form__selectPlaceholder" },
            [_vm._v("\n        " + _vm._s(_vm.selectedOption.label) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selected,
              expression: "selected",
            },
          ],
          attrs: {
            name: _vm.name,
            id: _vm.id,
            autocomplete: _vm.autocomplete,
            disabled: _vm.disabled,
          },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selected = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm._l(_vm.options, function (option) {
            return _c(
              "option",
              {
                key: option[_vm.optionValueKey],
                domProps: { value: option[_vm.optionValueKey] },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(option[_vm.optionLabelKey]) +
                    "\n        "
                ),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }